import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import {
  SeguimientosProgramaService,
  SeguimientosPrograma,
} from "../../../../../shared/services/seguimientos-programa.service";
import { catchError, forkJoin, of } from "rxjs";
import { PropietarioService } from "../../../../../shared/services/propietarios.service";
import { EstadoPlanAccionService } from "../../../../../shared/services/estado-plan-accion.service";
import { Utils } from "../../../../../shared/utils/Utils";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AdministracionService } from "../../../../../shared/services/administracion.services";
import { DigitalesService } from "../../../../../shared/services/digitales.service";
import { HttpEventType } from "@angular/common/http";

@Component({
  selector: "app-seguimientos",
  templateUrl: "./seguimientos.component.html",
  styleUrls: ["./seguimientos.component.scss"],
})
export class SeguimientosComponent implements OnInit {
  @ViewChild("modalSeguimiento") modalSeguimiento!: TemplateRef<any>;

  ProgramaID!: number;
  seguimientos: any[] = [];
  seguimientosFiltrados: SeguimientosPrograma[] = [];
  cargando = false;
  pageSize = 5;
  page = 1;
  totalItems: number = 0;
  paginaActual = 1;
  modalRef!: NgbModalRef;
  modoEdicion = false;
  idSeguimientoEditando: number | null = null;
  avanceBaseEdicion: number | null = null;
  formSeguimiento!: FormGroup;
  guardando = false;
  resultados = [
    { id: 1, nombre: "Cumplido", color: "success" },
    { id: 2, nombre: "En proceso", color: "warning" },
    { id: 3, nombre: "No cumplido", color: "danger" },
  ];

  listaSeguimientos: SeguimientosPrograma[] = [];
  filteredSeguimientos: SeguimientosPrograma[] = [];
  responsables: any[] = [];
  estadosSeguimiento: any[] = [];
  terminoBusqueda = "";
  filtroEstado: number | null = null;
  subiendoDocumentos = false;
  nit: string | null = null;
  planSeleccionadoDocs: any = null;
  documentosPlan: {
    path: string;
    name: string;
    url: string;
    isImage: boolean;
  }[] = [];
  nuevosArchivosDocs: { file: File; preview: string | null }[] = [];
  cargandoDocumentos = false;
  administraciones: any[] = [];
  seguimientoSeleccionadoDocs: any = null;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private seguimientosProgramaService: SeguimientosProgramaService,
    private propietarioService: PropietarioService,
    private estadoPlanAccionService: EstadoPlanAccionService,
    private sanitizer: DomSanitizer,
    private administracionesServices: AdministracionService,

    private digitalesService: DigitalesService,
  ) {}

  ngOnInit(): void {
    this.ProgramaID = Number(this.route.snapshot.paramMap.get("id"));
    this.construirFormulario();
    this.cargarDatosIniciales();
    this.cargarAdministraciones();
  }

  // 🔹 Formulario reactivo
  construirFormulario(): void {
    this.formSeguimiento = this.fb.group({
      responsable: [null, Validators.required],
      avance: [
        0,
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
      resultado: [null, Validators.required],
      observaciones: ["", [Validators.required, Validators.maxLength(2000)]],
    });

    this.formSeguimiento.get("avance")?.valueChanges.subscribe((valor) => {
      this.sincronizarResultadoPorAvance(Number(valor ?? 0));
    });
  }

  private cargarDatosIniciales(): void {
    this.cargando = true;

    forkJoin({
      seguimientos: this.seguimientosProgramaService
        .getSeguimientosProgramaByProgramaId(this.ProgramaID)
        .pipe(catchError(() => of([]))),
      responsables: this.propietarioService
        .getPlanAccion()
        .pipe(catchError(() => of([]))),
      estadosSeguimiento: this.estadoPlanAccionService
        .getEstados()
        .pipe(catchError(() => of([]))),
    }).subscribe((resultado) => {
      this.listaSeguimientos = resultado.seguimientos || [];
      this.estadosSeguimiento = resultado.estadosSeguimiento || [];
      this.filteredSeguimientos = [...this.listaSeguimientos];
      console.log("Responsables cargados:", resultado.responsables);
      this.responsables = this.normalizarLista(resultado.responsables).map(r => ({
        ...r,
        nombreCompleto: [
          r.cedula + "-",
          r.primernombre,
          r.segundonombre,
          r.papellidos,
          r.seapellidos
        ].filter(Boolean).join(' ')
      }));
      this.cargando = false;
    });
  }

 private normalizarLista(response: any): any[] {
  if (Array.isArray(response)) return response;

  if (Array.isArray(response?.data)) return response.data;

  if (Array.isArray(response?.responsables)) return response.responsables;

  if (Array.isArray(response?.propietarios)) return response.propietarios;

  // Si la respuesta es un objeto individual, convertirlo en array
  if (response && typeof response === 'object') {
    return [response];
  }

  return [];
}

  filtrar(): void {
    const termino = this.terminoBusqueda.trim().toLowerCase();

    this.filteredSeguimientos = this.listaSeguimientos.filter((segui: any) => {
      const coincideTexto =
        !termino ||
        [segui.observaciones, segui.nombre_responsable]
          .filter((valor) => valor !== null && valor !== undefined)
          .some((valor) => String(valor).toLowerCase().includes(termino));

      const coincideEstado =
        this.filtroEstado === null ||
        Number(segui.estado) === this.filtroEstado;

      return coincideTexto && coincideEstado;
    });

    this.page = 1;
  }

  private obtenerOrdenSeguimiento(seg: any): number {
    const fecha = seg?.fecha || seg?.fecha_seguimiento || seg?.fechaCreacion || seg?.fecha_creacion;
    const tiempo = fecha ? new Date(fecha).getTime() : 0;
    const id = Number(seg?.id ?? 0);
    return tiempo > 0 ? tiempo : id;
  }

  get avanceMinimoPermitidoNuevoSeguimiento(): number {
    if (this.modoEdicion) {
      return 0;
    }

    const activos = (Array.isArray(this.listaSeguimientos) ? this.listaSeguimientos : []).filter(
      (seg: any) => Number(seg?.estado ?? 1) === 1,
    );

    if (activos.length === 0) {
      return 0;
    }

    const ultimo = [...activos].sort(
      (a: any, b: any) => this.obtenerOrdenSeguimiento(b) - this.obtenerOrdenSeguimiento(a),
    )[0];

    const avance = Number(ultimo?.avance ?? 0);
    if (!Number.isFinite(avance)) {
      return 0;
    }

    return Math.min(100, Math.max(0, avance));
  }

  private programaCompletadoParaSeguimiento(): boolean {
    return this.avanceMinimoPermitidoNuevoSeguimiento >= 100;
  }

  private obtenerEstadoResultadoPorAvance(avance: number): number {
    const esCompletado = Number(avance) >= 100;
    const termino = esCompletado ? "complet" : "progres";

    const estado = (Array.isArray(this.estadosSeguimiento) ? this.estadosSeguimiento : []).find(
      (item: any) => String(item?.descripcion || "").toLowerCase().includes(termino),
    );

    if (estado?.id) {
      return Number(estado.id);
    }

    return esCompletado ? 3 : 2;
  }

  private sincronizarResultadoPorAvance(avance: number): void {
    const estadoResultado = this.obtenerEstadoResultadoPorAvance(avance);
    this.formSeguimiento.patchValue({ resultado: estadoResultado }, { emitEvent: false });
  }

  abrirModalCrear(): void {
    if (this.programaCompletadoParaSeguimiento()) {
      Swal.fire(
        "Validación",
        "El programa ya alcanzó el 100% de avance. No se pueden crear más seguimientos.",
        "warning",
      );
      return;
    }

    this.modoEdicion = false;
    this.idSeguimientoEditando = null;
    this.avanceBaseEdicion = null;
    const avanceInicial = this.avanceMinimoPermitidoNuevoSeguimiento;
    this.formSeguimiento.reset({ avance: avanceInicial });
    this.sincronizarResultadoPorAvance(avanceInicial);
    this.formSeguimiento.get("resultado")?.disable({ emitEvent: false });
    this.modalRef = this.modalService.open(this.modalSeguimiento, {
      size: "lg",
      backdrop: "static",
    });
  }

  abrirModalEditar(seguimiento: SeguimientosPrograma): void {
    this.modoEdicion = true;
    this.idSeguimientoEditando = seguimiento.id ?? null;
    this.avanceBaseEdicion = Number(seguimiento.avance ?? 0);
    this.formSeguimiento.get("resultado")?.disable({ emitEvent: false });

    this.formSeguimiento.patchValue({
      responsable: seguimiento.responsable,
      avance: seguimiento.avance,
      resultado: seguimiento.resultado,
      observaciones: seguimiento.observaciones,
    });

    this.modalRef = this.modalService.open(this.modalSeguimiento, {
      size: "lg",
      backdrop: "static",
    });
  }

  guardar(): void {
    if (this.formSeguimiento.invalid) {
      this.formSeguimiento.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Por favor revisa los campos del formulario.",
        "warning",
      );
      return;
    }

    const valores = this.formSeguimiento.getRawValue();
    const avanceIngresado = Number(valores.avance ?? 0);
    this.sincronizarResultadoPorAvance(avanceIngresado);
    const resultadoFinal = this.obtenerEstadoResultadoPorAvance(avanceIngresado);

    const minimoPermitido = this.modoEdicion
      ? Math.min(100, Math.max(0, Number(this.avanceBaseEdicion ?? 0)))
      : this.avanceMinimoPermitidoNuevoSeguimiento;

    if (avanceIngresado < minimoPermitido) {
      this.formSeguimiento.get("avance")?.setErrors({ avanceMinimo: true });
      this.formSeguimiento.get("avance")?.markAsTouched();
      Swal.fire(
        "Validación",
        this.modoEdicion
          ? `En edición, el avance no puede ser menor al valor actual (${minimoPermitido}%).`
          : `El nuevo seguimiento no puede tener un avance menor a ${minimoPermitido}%.`,
        "warning",
      );
      return;
    }

    if (!this.modoEdicion) {
      if (this.programaCompletadoParaSeguimiento()) {
        Swal.fire(
          "Validación",
          "El programa ya alcanzó el 100% de avance. No se pueden crear más seguimientos.",
          "warning",
        );
        return;
      }

    }

    const payload: SeguimientosPrograma = {
      id_programa: this.ProgramaID,
      responsable: valores.responsable,
      avance: avanceIngresado,
      resultado: resultadoFinal,
      observaciones: valores.observaciones,
    };

    this.guardando = true;

    const peticion$ =
      this.modoEdicion && this.idSeguimientoEditando
        ? this.seguimientosProgramaService.updateSeguimiento(
            this.idSeguimientoEditando,
            payload,
          )
        : this.seguimientosProgramaService.createSeguimiento(payload);

    peticion$.subscribe({
      next: () => {
        this.guardando = false;
        this.modalRef.close();
        Swal.fire(
          "Listo",
          `Seguimiento ${this.modoEdicion ? "actualizado" : "creado"} correctamente.`,
          "success",
        );
        this.cargarDatosIniciales();
      },
      error: (err) => {
        this.guardando = false;
        console.error("Error al guardar seguimiento:", err);
        Swal.fire("Error", "No fue posible guardar el seguimiento.", "error");
      },
    });
  }

  cambiarEstado(seguimiento: SeguimientosPrograma): void {
    const activo = seguimiento.estado === 1;
    const accion$ = activo
      ? this.seguimientosProgramaService.inactivar(seguimiento.id!)
      : this.seguimientosProgramaService.activar(seguimiento.id!);

    Swal.fire({
      title: activo ? "Inactivar" : "Activar",
      text: activo
        ? "¿Desea inactivar el seguimiento?"
        : "¿Desea activar el seguimiento?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#0d6efd", // 🔹 azul (primary), ajústalo si usas otro tono
      cancelButtonColor: "#dc3545", // 🔹 rojo (danger)
    }).then((res) => {
      if (res.isConfirmed) {
        accion$.subscribe({
          next: () => {
            Swal.fire(
              "Listo",
              `Seguimiento ${activo ? "inactivado" : "activado"}.`,
              "success",
            );
            this.cargarDatosIniciales();
          },
          error: (err) => {
            console.error(err);
            Swal.fire("Error", "No fue posible cambiar el estado.", "error");
          },
        });
      }
    });
  }

  cerrarModal(): void {
    this.modalRef?.dismiss();
  }

  colorAvance(avance: number): string {
    if (avance >= 80) return "success";
    if (avance >= 40) return "warning";
    return "danger";
  }

  nombreResultado(id: number): string {
    return this.resultados.find((r) => r.id === id)?.nombre ?? "-";
  }

  colorResultado(id: number): string {
    return this.resultados.find((r) => r.id === id)?.color ?? "secondary";
  }

  getEstadoBadgeClass(estado: number | undefined): string {
    return estado === 1 ? "bg-success" : "bg-danger";
  }

  getEstadoResultadoBadgeClass(estado: number | undefined): string {
    return estado === 1 ? "bg-success" : "bg-danger";
  }

  getEstadoPlanBadgeClass(value: any): string {
    const estado = Number(value);
    const clases: Record<number, string> = {
      1: "bg-secondary", // PENDIENTE
      2: "bg-primary", // EN PROGRESO
      3: "bg-success", // COMPLETADO
      4: "bg-danger", // VENCIDO
    };
    return clases[estado] || "bg-secondary";
  }

  exportarExcel(tablaId: string, nombreArchivo: string): void {
    Utils.exportVisibleTableToExcel(tablaId, nombreArchivo);
  }

  exportToPDF(tablaId: string, nombreArchivo: string, titulo: string): void {
    Utils.exportToPDF(tablaId, nombreArchivo, titulo);
  }

  private construirCarpetaSeguimiento(seguimiento: any): string {
    return `pesv/programa/seguimiento/${this.ProgramaID}/${seguimiento.id}`;
  }

  private esImagenPorNombre(nombre: string): boolean {
    const ext = nombre.split(".").pop()?.toLowerCase() ?? "";
    return ["jpg", "jpeg", "png", "webp"].includes(ext);
  }

  private isImageFile(file: File): boolean {
    return ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
      file.type,
    );
  }

  private generarNombreArchivo(indice: number = 0): string {
    const ahora = new Date();
    const yyyy = ahora.getFullYear();
    const mm = String(ahora.getMonth() + 1).padStart(2, "0");
    const dd = String(ahora.getDate()).padStart(2, "0");
    const hh = String(ahora.getHours()).padStart(2, "0");
    const mi = String(ahora.getMinutes()).padStart(2, "0");
    const ss = String(ahora.getSeconds()).padStart(2, "0");
    const ms = String(ahora.getMilliseconds()).padStart(3, "0");
    const aleatorio = Math.floor(Math.random() * 100000)
      .toString()
      .padStart(5, "0");

    return `seg_${yyyy}${mm}${dd}_${hh}${mi}${ss}_${ms}_${indice + 1}_${aleatorio}`;
  }

  abrirModalDocumentos(modalRef: any, seguimiento: any): void {
    if (!this.nit) {
      this.mostrarAlerta(
        "Atención",
        "Aún se está cargando la información de la administración. Intente de nuevo en un momento.",
        "warning",
      );
      return;
    }

    this.seguimientoSeleccionadoDocs = seguimiento;
    this.nuevosArchivosDocs = [];
    this.documentosPlan = [];
    this.cargarDocumentosPlan(seguimiento);

    this.modalService.open(modalRef, {
      size: "lg",
      centered: true,
      backdrop: "static",
    });
  }

  cargarDocumentosPlan(seguimiento: any): void {
    if (!this.nit) return;

    this.cargandoDocumentos = true;
    const carpeta = this.construirCarpetaSeguimiento(seguimiento); // pesv/programa/seguimiento/{id_programa}/{id_seguimiento}
    const rutaCompleta = `${this.nit}/${carpeta}`;

    this.digitalesService.getDocumentosPlanAccion(rutaCompleta).subscribe({
      next: (resp) => {
        this.documentosPlan = (resp.archivos ?? []).map((a: any) => ({
          name: a.name,
          path: a.path,
          url: a.url,
          isImage: this.esImagenPorNombre(a.name),
        }));
        this.cargandoDocumentos = false;
      },
      error: () => {
        this.documentosPlan = [];
        this.cargandoDocumentos = false;
      },
    });
  }

  subirDocumentosPlan(): void {
    if (
      !this.seguimientoSeleccionadoDocs ||
      this.seguimientoSeleccionadoDocs.estado === 0 ||
      this.nuevosArchivosDocs.length === 0 ||
      !this.nit
    ) {
      return;
    }
    // ... resto igual

    this.subiendoDocumentos = true;
    const carpeta = this.construirCarpetaSeguimiento(
      this.seguimientoSeleccionadoDocs,
    );
    const rutaCompleta = `${this.nit}/${carpeta}`;
    const pendientes = this.nuevosArchivosDocs.length;
    let completados = 0;
    let subidosConExito = 0;

    this.nuevosArchivosDocs.forEach((item, index) => {
      // 🔹 Nombre único por archivo para evitar que se sobreescriban entre sí
      // (ej. varias fotos de cámara que llegan con el mismo nombre "image.jpg")
      const nombreArchivo = this.generarNombreArchivo(index);
      console.log(`Subiendo archivo: ${item.file.name} como ${nombreArchivo}`);
      this.digitalesService
        .subirDocumentoPlanAccion(
          item.file,
          rutaCompleta,
          nombreArchivo,
          "SP",
        )
        .subscribe({
          next: (event) => {
            if (event.type === HttpEventType.Response) {
              completados++;
              subidosConExito++;

              if (completados === pendientes) {
                this.subiendoDocumentos = false;
                this.nuevosArchivosDocs = [];
                this.cargarDocumentosPlan(this.seguimientoSeleccionadoDocs);
                this.mostrarAlerta(
                  "¡Éxito!",
                  "Documento(s) subido(s) correctamente.",
                  "success",
                );
              }
            }
          },
          error: () => {
            completados++;
            this.subiendoDocumentos = false;

            if (completados === pendientes) {
              this.cargarDocumentosPlan(this.seguimientoSeleccionadoDocs);
              if (subidosConExito > 0) {
              }
            }

            this.mostrarAlerta(
              "Error",
              `No se pudo subir el archivo ${item.file.name}.`,
              "error",
            );
          },
        });
    });
  }

  onFileChangeDocumento(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.nuevosArchivosDocs.push({
          file,
          preview: this.isImageFile(file) ? e.target.result : null,
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = "";
  }

  quitarArchivoNuevo(index: number): void {
    this.nuevosArchivosDocs.splice(index, 1);
  }

  eliminarDocumento(doc: { name: string; path: string; url: string }): void {
    if (
      !this.seguimientoSeleccionadoDocs ||
      this.seguimientoSeleccionadoDocs.estado === 0
    ) {
      this.mostrarAlerta(
        "Acción no permitida",
        "No se puede eliminar documentos de un seguimiento inactivo.",
        "warning",
      );
      return;
    }

    Swal.fire({
      title: "¿Eliminar documento?",
      // ... resto igual
      text: `¿Está seguro de que desea eliminar "${doc.name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.digitalesService.eliminarArchivo(doc.path).subscribe({
          next: () => {
            this.cargarDocumentosPlan(this.seguimientoSeleccionadoDocs); // 🔹 antes: this.planSeleccionadoDocs
            this.mostrarAlerta(
              "¡Éxito!",
              "El documento se eliminó correctamente.",
              "success",
            );
          },
          error: () => {
            this.mostrarAlerta(
              "Error",
              "No se pudo eliminar el documento.",
              "error",
            );
          },
        });
      }
    });
  }

  reemplazarDocumento(doc: { name: string; path: string }): void {
    if (
      !this.seguimientoSeleccionadoDocs ||
      this.seguimientoSeleccionadoDocs.estado === 0
    ) {
      this.mostrarAlerta(
        "Acción no permitida",
        "No se puede reemplazar documentos de un seguimiento inactivo.",
        "warning",
      );
      return;
    }

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".pdf,.jpg,.jpeg,.png,.webp";
    // ... resto igual

    input.onchange = (event: any) => {
      const file: File = event.target.files[0];
      if (!file) return;

      Swal.fire({
        title: "¿Reemplazar documento?",
        text: `Se reemplazará "${doc.name}" por "${file.name}".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, reemplazar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.subiendoDocumentos = true;

        this.digitalesService.eliminarArchivo(doc.path).subscribe({
          next: () => {
            const carpeta = this.construirCarpetaSeguimiento(
              this.seguimientoSeleccionadoDocs,
            );
            const rutaCompleta = `${this.nit}/${carpeta}`;
            const nombreArchivo = this.generarNombreArchivo();
            
            this.digitalesService
              .subirDocumentoPlanAccion(
                file,
                rutaCompleta,
                nombreArchivo,
                "SP",
              )
              .subscribe({
                next: (event) => {
                  if (event.type === HttpEventType.Response) {
                    this.subiendoDocumentos = false;
                    this.cargarDocumentosPlan(this.seguimientoSeleccionadoDocs);
                    this.mostrarAlerta(
                      "¡Éxito!",
                      "Documento reemplazado correctamente.",
                      "success",
                    );
                  }
                },
                error: () => {
                  this.subiendoDocumentos = false;
                  this.mostrarAlerta(
                    "Error",
                    "No se pudo subir el nuevo documento.",
                    "error",
                  );
                },
              });
          },
          error: () => {
            this.subiendoDocumentos = false;
            this.mostrarAlerta(
              "Error",
              "No se pudo eliminar el documento anterior.",
              "error",
            );
          },
        });
      });
    };

    input.click();
  }

  private cargarAdministraciones(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data: any[]) => {
        this.administraciones = data ?? [];
        this.nit = this.administraciones?.[0]?.nit ?? null;
      },
      error: () => {
        this.administraciones = [];
        this.nit = null;
      },
    });
  }

  documentoSeleccionado: {
    name: string;
    path: string;
    url: string;
    urlSegura?: SafeResourceUrl; // 👈 nuevo, solo se usa para el iframe
    isImage: boolean;
    isPdf: boolean;
    tipo: string;
  } | null = null;

  private obtenerTipoDocumento(
    nombre: string,
  ): "imagen" | "pdf" | "word" | "excel" | "otro" {
    const ext = nombre.split(".").pop()?.toLowerCase() ?? "";
    if (["jpg", "jpeg", "png", "webp"].includes(ext)) return "imagen";
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    if (["xls", "xlsx"].includes(ext)) return "excel";
    return "otro";
  }

  verDocumento(
    modalRef: any,
    doc: { name: string; path: string; url: string; isImage: boolean },
  ): void {
    if (!doc.url) return;

    const tipo = this.obtenerTipoDocumento(doc.name);

    this.documentoSeleccionado = {
      ...doc,
      isImage: tipo === "imagen",
      isPdf: tipo === "pdf",
      tipo,
      urlSegura:
        tipo === "pdf"
          ? this.sanitizer.bypassSecurityTrustResourceUrl(doc.url)
          : undefined,
    };

    this.modalService.open(modalRef, {
      size: "xl",
      centered: true,
      backdrop: true,
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any): void {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }
}
